import { render } from "./PackageSpecCardLoading.vue?vue&type=template&id=6a4e452c&scoped=true"
import script from "./PackageSpecCardLoading.vue?vue&type=script&lang=js"
export * from "./PackageSpecCardLoading.vue?vue&type=script&lang=js"

import "./PackageSpecCardLoading.vue?vue&type=style&index=0&id=6a4e452c&lang=scss&scoped=true"

import exportComponent from "/home/mon3m/mon3m/dafater/ManageSPA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a4e452c"]])

export default __exports__